import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Download, Eye, FileText, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/PageHeader";
import api, { apiError } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const download = async (d) => {
  try {
    const r = await api.get(`/documents/${d.id}/file`, { params: { download: true }, responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    Object.assign(document.createElement("a"), { href: url, download: `${d.title}.pdf` }).click();
  } catch (e) { toast.error(apiError(e)); }
};

export default function DocumentsPage() {
  const [docs, setDocs] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/documents").then((r) => setDocs(r.data.documents)).catch((e) => toast.error(apiError(e))); }, []);
  return (
    <div className="space-y-5" data-testid="documents-page">
      <PageHeader brand eyebrow="Work" title="Documents" subtitle="Documents shared with you." />
      <div className="overflow-hidden rounded-lg border border-slate-200 bg-white" data-testid="documents-list">
        {!docs && <div className="p-6"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>}
        {docs?.length === 0 && <p className="px-4 py-10 text-center text-sm text-slate-500" data-testid="documents-empty">No documents shared with you</p>}
        {docs?.map((d) => (
          <div key={d.id} className="flex items-center gap-3 border-t border-slate-100 px-4 py-3" data-testid={`document-row-${d.id}`}>
            <FileText className="h-5 w-5 text-teal-600" />
            <div className="min-w-0 flex-1">
              <div className="truncate font-medium text-slate-900">{d.title}</div>
              <div className="text-xs text-slate-500">{d.company}{d.client && ` · for ${d.client}`} · v{d.version} · {fmtDate(d.created_at)}</div>
            </div>
            <Button variant="outline" size="sm" className="gap-1.5" onClick={() => navigate(`/documents/${d.id}`)} data-testid={`document-view-${d.id}`}><Eye className="h-4 w-4" /> View</Button>
            <Button variant="outline" size="sm" className="gap-1.5" onClick={() => download(d)} data-testid={`document-download-${d.id}`}><Download className="h-4 w-4" /> Download</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
